import React from 'react';
import clsx from 'clsx';
import { Colors } from 'works/legacy/lib/style-helper';
import { Collapse as AntCollapse, CollapseProps } from 'antd';
import { Animation, Icon } from '@common/components';

type Props = {
  textSize?: 'sm' | 'md' | 'lg';
} & CollapseProps;

const FONT_SIZE_MAP = {
  sm: 12,
  md: 14,
  lg: 16,
};

export function Collapse({
  className,
  style,
  textSize = 'md',
  ...props
}: Props) {
  return (
    <>
      <AntCollapse
        {...props}
        className={clsx('wk-collapse', className)}
        expandIcon={({ isActive }) => (
          <div>
            <Animation
              active={!!isActive}
              kind="rotate-right"
              rotationDegree={90}
            >
              <Icon icon="angleRight" kind="light" color="elm" />
            </Animation>
          </div>
        )}
        ghost
        style={{
          ...style,
          fontSize: FONT_SIZE_MAP[textSize],
        }}
      />
      <style jsx>{`
        :global(.wk-collapse > .ant-collapse-item > .ant-collapse-header) {
          color: ${Colors.elm};
          cursor: pointer;
          font-size: 16px;
          font-weight: 500;
        }
        :global(.wk-collapse .wk-icon) {
          margin-top: 3px;
          margin-bottom: -3px;
        }
      `}</style>
    </>
  );
}

Collapse.Panel = AntCollapse.Panel;
